// extracted by mini-css-extract-plugin
export default {"container":"PropMap_container__h8T4G","title":"PropMap_title__sx1yB"};